import { cn } from '@/lib/utils'

function formatPlanName(plan: string): string {
  return plan
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((part) => `${part.slice(0, 1).toUpperCase()}${part.slice(1)}`)
    .join(' ') || 'Plan'
}

export function PlanBadge({ plan, className }: { plan: string; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider',
        'border border-violet-500/20 bg-violet-500/10 text-violet-300',
        className
      )}
    >
      {formatPlanName(plan)}
    </span>
  )
}
